import type { MutationKey, QueryKey } from "@tanstack/react-query"

enum EMutationKeyBase {
    SubmitLikertQuestion = "SubmitLikertQuestion",
    CompleteChapter = "CompleteChapter"
}

const EMutationKey: {
    SubmitLikertQuestion(chapterId: number, chapterComponentUuid: string): MutationKey
    CompleteChapter(chapterId: number): MutationKey
} = {
    SubmitLikertQuestion: (chapterId: number, chapterComponentUuid: string): MutationKey => [
        EMutationKeyBase.SubmitLikertQuestion,
        chapterId,
        chapterComponentUuid
    ],
    CompleteChapter: (chapterId: number): MutationKey => [EMutationKeyBase.CompleteChapter, chapterId]
}

const EMutationUrl: {
    SubmitLikertQuestion(chapterId: number): string
    CompleteChapter(chapterId: number): string
} = {
    SubmitLikertQuestion: (chapterId: number): string => `/api/participant-chapter/${chapterId}/update-question-group/`,
    CompleteChapter: (chapterId: number): string => `/api/participant-chapter/${chapterId}/`
}

const EQueryKey: {
    ChapterById(chapterId: number): QueryKey
} = {
    ChapterById: (chapterId: number): QueryKey => ["ChapterById", `chapterId:${chapterId}}`]
} as const

const EQueryUrl: {
    ChapterById(chapterId: number): string
} = {
    ChapterById: (chapterId: number): string => `/api/participant-chapter/${chapterId}/get_chapter_data/`
}

export {
    EMutationKey as EParticipantChapterMutationKey,
    EMutationKeyBase as EParticipantChapterMutationKeyBase,
    EMutationUrl as EParticipantChapterMutationUrl,
    EQueryKey as EParticipantChapterQueryKey,
    EQueryUrl as EParticipantChapterQueryUrl
}
